import React from 'react';
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  Typography,
} from '@mui/material';
import { TICKET_STATUSES } from '../../../constants/tickets';

export default function TicketBulkActions({
  selectedCount,
  bulkStatus,
  bulkUpdating,
  onBulkStatusChange,
  onApplyBulkStatus,
  onClearSelection,
}) {
  return (
    <Paper variant="outlined" sx={{ mb: 2, p: 1.5 }}>
      <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap" useFlexGap>
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {selectedCount} selected
        </Typography>
        <FormControl size="small" sx={{ minWidth: 180 }}>
          <InputLabel id="bulk-ticket-status-label" shrink>
            New status
          </InputLabel>
          <Select
            labelId="bulk-ticket-status-label"
            label="New status"
            value={bulkStatus}
            onChange={(e) => onBulkStatusChange(e.target.value)}
            displayEmpty
            notched
          >
            <MenuItem value="" disabled>
              <em>Choose status…</em>
            </MenuItem>
            {TICKET_STATUSES.map((s) => (
              <MenuItem key={s.id} value={s.id}>
                {s.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          variant="contained"
          disabled={!bulkStatus || bulkUpdating}
          onClick={onApplyBulkStatus}
        >
          {bulkUpdating ? 'Updating…' : 'Update status'}
        </Button>
        <Button size="small" onClick={onClearSelection} disabled={bulkUpdating}>
          Clear selection
        </Button>
      </Stack>
    </Paper>
  );
}
